export default {
  email: "{field}格式不正确",
  required: "请填写{field}",
  numeric: "{field}格式不正确",
  unknown: "发生问题，请重新整理后再试一次。如果问题仍然持续，请电邮至support@edcity.hk。",
  image: "{field} 不是可识别的图像文件格式。",
  recaptcha: "请验证您不是自动程式。",
  sameAs: "{field} 与 {sameAsField} 不相同",
  maxLength: "{field} 的最大长度已超过",
  verifyCode:{
    invalid: "验证码错误。",
    expired: "验证码已逾时，请返回重新发送。",
    notFound:"找不到对应记录，请返回重新发送。",
    emailDuplicate:"电邮地址已用于其他教城帐户作登入电邮，请返回后用其他电邮地址重新发送。",
    sixDigit: "{field} 必须是六位数字。"
  },
};
